<script setup>
    // Libraries
    import { storeToRefs } from 'pinia';

    // Stores
    import { useUserStore } from '@/stores/user';
    import { useToursStore } from '@/stores/tours';

    // Variables
    const { itineraries: userItineraries } = storeToRefs(useUserStore());
    const { toursData: tours } = storeToRefs(useToursStore());

    // Computed
    const allTours = computed(() => {
        const tourRecords = tours.value?.records || [];
        const userItin = userItineraries.value || [];
        
        if (userItin.length > 0) {
            return [...tourRecords, ...userItin];
        }
        return tourRecords;
    });
</script>

<template>
    <section class="tours-overview">
        <div class="hd-container"  v-if="allTours && allTours.length > 0">
            <BlocksToursList includeFilters :showViewAll="false" :items="allTours" :headline="'h1'" v-if="allTours && allTours.length > 0" />
        </div>
        <div v-else class="no-tours-message container">
            <h1>Itineraries</h1>
            <p>No itineraries are currently available.</p>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .tours-overview {
        .no-tours-message {
            padding: 40px 20px;
            text-align: center;
            
            h1 {
                margin-bottom: 20px;
            }
        }
        
        .filters {
            display: flex;
            margin-bottom: 18px;
            .filter-icon {
                flex-shrink: 0;
                margin-right: 16px;
            }

            .select {
                label {
                    display: block;
                    margin-bottom: 16px;
                }
            }
        }

        @media (min-width: $tablet) {
            width: 100%;
            max-width: $hd;
            margin: auto;
            grid-gap: 20px;
        }
    }
</style>
